import ConnersParentScale from "./connersParentScale.vue";
export default ConnersParentScale;

